module.exports = __webpack_public_path__ + "static/media/leader.0d9c07ac.png";